import { httpRequest } from "../../http";

export class CommandGetKeyDate {
    async run(engagementId: number, objectiveId: number) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/${engagementId}/objectives/${objectiveId}/key-dates/`
        try {
            const response = await httpRequest<any>(url, { method: "GET" });
            return response;
            
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }
}

